// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import TaskDrawerData from '@Organisms/Task/TaskDrawerData/TaskDrawerData';
import THDrawer from '@Molecules/THDrawer/THDrawer';
import { TaskOutput } from 'thehive-sdk';
import { TaskEventList } from '../eventList';
import { useLocalMessage } from '@Helpers/locale';
import { Space } from 'antd';
import { ActionListRendererParams } from '@Helpers/actionListRenderer';
import { ICONS } from '@Constants/iconsApp';

import './TaskDrawer.scss';

export interface TaskDrawerProps {
    data: TaskOutput;
    caseId: string;
    eventList: TaskEventList;
    actionList?: ActionListRendererParams<TaskOutput>;
    hasPermissions?: boolean;
    defaultVisible?: boolean;
    onVisibleChange?: (visible: boolean) => void;
    visible: boolean;
}

const TaskDrawer = ({
    data,
    caseId,
    eventList,
    actionList,
    hasPermissions,
    defaultVisible = false,
    onVisibleChange,
    visible,
}: TaskDrawerProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <THDrawer
            title={
                <Space>
                    <ICONS.TaskIcon />
                    {i('task.preview')}
                </Space>
            }
            className="drawer-form"
            width="50vw"
            defaultVisible={defaultVisible}
            afterVisibleChange={onVisibleChange}
            visible={visible}
        >
            <>
                {data && (
                    <TaskDrawerData
                        task={data}
                        caseId={caseId}
                        eventList={eventList}
                        actionList={actionList}
                        hasPermissions={hasPermissions}
                    />
                )}
            </>
        </THDrawer>
    );
};

export default TaskDrawer;
